import { Injectable, ApplicationRef, NgZone } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

/**
 * In this environment XMLHttpRequest is not zone.js-patched, so Angular's automatic
 * change detection never runs after an HttpClient response arrives (components update
 * their fields but the view stays stale, e.g. spinners that never clear). This forces
 * a full app tick on every HTTP emission/completion regardless of which zone it fired in.
 */
@Injectable()
export class ZoneFixInterceptor implements HttpInterceptor {

  constructor(private ngZone: NgZone, private appRef: ApplicationRef) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(() => this.tick()),
      finalize(() => this.tick())
    );
  }

  private tick(): void {
    this.ngZone.run(() => {
      try {
        this.appRef.tick();
      } catch {
        // A tick already in progress elsewhere - safe to ignore, another tick will follow.
      }
    });
  }
}
